import React from "react";
import FavoriteIcon from '@mui/icons-material/Favorite';
import CopyrightBannerStyle from "styles/CopyrightBanner.style";

export default function CopyrightBanner() {
    const currentYear = new Date().getFullYear();
    return (
        <footer
            id="copyright-banner"
            style={{ ...CopyrightBannerStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 20, padding: '12px 24px' }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                <div className="credits" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <FavoriteIcon fontSize="inherit" style={{ color: '#E10600', fontSize: 18 }} className="heart-icon" />
                    <span className="credits-text" style={{ fontSize: 14 }}>Crafted by Netsolace</span>
                </div>
            </div>
            <div style={{ textAlign: 'right', fontSize: 14, lineHeight: 1.5 }} className="footer-legal">
                <div className="copyright-info" style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                    <span className="copyright-symbol" style={{ fontSize: 14 }}>&copy;</span>
                    <span className="copyright-year" style={{ fontSize: 14 }}>{currentYear}</span>
                    <span className="company-name" style={{ fontWeight: 600, fontSize: 14 }}>Edible Brands, LLC</span>
                </div>
                <div className="legal-text" style={{ fontSize: 13 }}>All rights reserved</div>
            </div>
        </footer>
    )
};
